import {
  DetailedHTMLProps,
  HTMLAttributes,
  ReactNode,
  TdHTMLAttributes,
} from 'react';
import classNames from 'classnames';

interface TableProps {
  headers?: ReactNode[];
  children?: ReactNode;
}

export function TableCell(
  props: DetailedHTMLProps<
    TdHTMLAttributes<HTMLTableDataCellElement>,
    HTMLTableDataCellElement
  >,
) {
  return (
    <td {...props} className={classNames('px-6 py-4', props.className)}>
      {props.children}
    </td>
  );
}

export function Table(props: TableProps) {
  return (
    <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
      <table className="min-w-full divide-y divide-gray-200 text-sm">
        <thead className="bg-gray-50">
          <tr>
            {props.headers?.map((header, i) => (
              <th
                key={i}
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y">{props.children}</tbody>
      </table>
    </div>
  );
}
